import { defineTranslateKeys } from 'lib/tolgee'

export const translations = defineTranslateKeys({
  title: {
    key: 'document-error-title',
    defaultValue: 'Oops! Algo deu errado ao carregar os documentos.',
  },
  description: {
    key: 'document-error-description',
    defaultValue: 'Não foi possível carregar seus documentos. Tente novamente.',
  },
})
